import { combineReducers } from "redux";

import { initializingReducer } from "@/redux/initialState";
import createReducerManager from "@/redux/reducerManager";
import {
    $DataModuleName,
    IApiDataState,
    IValueState,
    TApiAction,
    TApiDataStateSlice,
    TValueAction
} from "@/redux/store.types";

import {
    $BoxCountModuleName,
    TBoxCounterState
} from "./api/data/boxCount/boxCount.types";
import {
    $BillingCountriesModuleName,
    TBillingCountriesState
} from "./api/data/countries/billing/billingCountries.types";
import {
    $PhonenumberPrefixesModuleName,
    TPhonenumberPrefixesState
} from "./api/data/phonenumberPrefixes/phonenumberPrefixes.types";
import {
    $ShopNamesModuleName,
    TShopNamesState
} from "./api/data/stores/shopNames/shopNames.types";
import {
    $VatPrefixesModuleName,
    TVatPrefixesState
} from "./api/data/vatPrefixes/vatPrefixes.types";
import ApiErrorsModule from "./api/errors/errors.reducer";
import { $ApiErrorsModuleName } from "./api/errors/errors.types";
import LoadingModule from "./api/loading/loading.reducer";
import { $LoadingModuleName } from "./api/loading/loading.types";
import { $ErrorsModuleName, TErrorsState } from "./value/errors/errors.types";
import {
    $FlyoutCategoriesModuleName,
    FlyoutCategory
} from "./value/flyoutCategories/flyoutCategories.types";
import {
    $PaintCollectionModuleName,
    TPaintCollectionState
} from "./value/paintCollection/paintCollection.types";
import {
    $ProductDetailModuleName,
    TProductDetailState
} from "./value/productDetail/productDetail.types";
import { $SearchModuleName, SearchState } from "./value/search/search.types";
import {
    $TranslationsModuleName,
    TTranslationsState
} from "./value/translations/translations.types";

export const apiDataReducerManager = createReducerManager<
    IApiDataState,
    TApiAction
>({
    [$PhonenumberPrefixesModuleName]: initializingReducer<
        TApiDataStateSlice<TPhonenumberPrefixesState>,
        IApiDataState,
        TApiAction
    >($PhonenumberPrefixesModuleName),
    [$BillingCountriesModuleName]: initializingReducer<
        TApiDataStateSlice<TBillingCountriesState>,
        IApiDataState,
        TApiAction
    >($BillingCountriesModuleName),
    [$ShopNamesModuleName]: initializingReducer<
        TApiDataStateSlice<TShopNamesState>,
        IApiDataState,
        TApiAction
    >($ShopNamesModuleName),
    [$VatPrefixesModuleName]: initializingReducer<
        TApiDataStateSlice<TVatPrefixesState>,
        IApiDataState,
        TApiAction
    >($VatPrefixesModuleName),
    [$BoxCountModuleName]: initializingReducer<
        TBoxCounterState,
        IApiDataState,
        TApiAction
    >($BoxCountModuleName)
});

export const apiReducer = combineReducers({
    [$LoadingModuleName]: LoadingModule,
    [$ApiErrorsModuleName]: ApiErrorsModule,
    [$DataModuleName]: apiDataReducerManager.reduce
});

export const valueReducerManager = createReducerManager<
    IValueState,
    TValueAction
>({
    [$TranslationsModuleName]: initializingReducer<
        TTranslationsState,
        IValueState,
        TValueAction
    >($TranslationsModuleName),
    [$ProductDetailModuleName]: initializingReducer<
        TProductDetailState,
        IValueState,
        TValueAction
    >($ProductDetailModuleName),
    [$FlyoutCategoriesModuleName]: initializingReducer<
        FlyoutCategory,
        IValueState,
        TValueAction
    >($FlyoutCategoriesModuleName),
    [$ErrorsModuleName]: initializingReducer<
        TErrorsState,
        IValueState,
        TValueAction
    >($ErrorsModuleName),
    [$SearchModuleName]: initializingReducer<
        SearchState,
        IValueState,
        TValueAction
    >($SearchModuleName),
    [$PaintCollectionModuleName]: initializingReducer<
        TPaintCollectionState,
        IValueState,
        TValueAction
    >($PaintCollectionModuleName)
});
